export const homeFAQ = [
  {
    question: '清文華泉 Cinva 是什麼品牌？',
    answer: '清文華泉 Cinva 以 AIGC 彩色書籍、科普與歷史類書籍為主要出版方向。品牌網站提供品牌介紹、正式出版書籍、合作購書通路及相關合作資訊。',
  },
  {
    question: '清文華泉與崧博出版是什麼關係？',
    answer: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。讀者可透過清文華泉品牌網站瀏覽相關出版內容，並前往崧博出版書籍資料庫查詢正式書目資訊。',
  },
  {
    question: '如何查詢清文華泉的完整書目資訊？',
    answer: '完整書名、作者、ISBN、出版日期及其他正式出版資訊，請前往崧博出版書籍資料庫查詢。',
  },
  {
    question: '清文華泉的書可以在哪裡購買？',
    answer: '讀者可透過清文華泉網站已建立的合作購書通路查找相關書籍。不同作品在各平台的上架狀態可能不同，實際商品資訊、價格與庫存請以各通路頁面為準。',
  },
  {
    question: '所有清文華泉書籍都會在每個通路上架嗎？',
    answer: '不一定。各書籍的紙本或電子版本、上架平台、銷售地區及供應狀態可能不同，請以各通路的正式商品頁面為準。',
  },
  {
    question: '在購書平台找不到清文華泉書籍怎麼辦？',
    answer: '建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再使用完整書名或作者名稱於其他合作通路查找。若仍無法找到，可能是尚未上架、暫時缺貨或平台搜尋結果尚未更新。',
  },
  {
    question: '為什麼同一本書在不同通路的價格可能不同？',
    answer: '不同平台可能依版本、格式、促銷活動、會員方案、配送方式或地區條件提供不同價格，實際售價與優惠請以各通路頁面為準。',
  },
  {
    question: '如何確認書籍是紙本書還是電子書？',
    answer: '購買前請確認平台商品頁所標示的版本、格式、出版社、ISBN及支援裝置。不同平台可能提供不同閱讀形式，請以各平台說明為準。',
  },
  {
    question: '書籍資料庫與購書平台資訊不一致時，以哪一邊為準？',
    answer: '書名、作者、ISBN與出版日期等正式書目資訊，請優先參考崧博出版書籍資料庫；價格、庫存、版本供應與配送方式，請以各購書通路的即時頁面為準。',
  },
  {
    question: '清文華泉提供電子書、POD或有聲書製作服務嗎？',
    answer: '清文華泉與崧博出版目前不提供電子書製作、POD、有聲書等出版製作代工服務。對外可洽詢品牌經銷與相關合作方案，詳情請直接聯繫。',
  },
  {
    question: '如何洽詢清文華泉品牌經銷或合作？',
    answer: '如有品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過官方聯絡方式提出詢問。實際合作內容與條件將依個別情況確認。品牌經銷與合作方案詳情請直接聯繫洽詢。',
  },
  {
    question: '可以直接在清文華泉網站購買書籍嗎？',
    answer: '清文華泉品牌網站主要提供品牌、書籍與合作通路資訊。實際購買方式請依網站所列的正式合作通路進行。',
  },
];

export const storePartners = [
  { name: '博客來', url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=sanmin98', description: '博客來網路書店' },
  { name: '誠品', url: 'https://www.eslite.com/search?keyword=清文華泉事業有限公司', description: '誠品線上' },
  { name: '金石堂', url: 'https://www.kingstone.com.tw/bookpublish/publist/62103/', description: '金石堂網路書店' },
  { name: '三民', url: 'https://www.sanmin.com.tw/search?pu=清文華泉', description: '三民網路書店' },
  { name: 'momo', url: 'https://www.momoshop.com.tw/search/清文華泉?brand=清文華泉', description: 'momo 購物網' },
  { name: '蝦皮', url: 'https://shopee.tw/sonbook', description: '蝦皮購物' },
  { name: 'Amazon Kindle', url: 'https://www.amazon.com/s?k=清文華泉', description: 'Amazon Kindle 電子書' },
  { name: 'TAAZE 讀冊', url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=清文華泉', description: 'TAAZE 讀冊生活' },
  { name: '樂天 Kobo', url: 'https://www.kobo.com/tw/zh', description: '樂天 Kobo 電子書' },
  { name: 'Pubu', url: 'https://www.pubu.com.tw/store/4193937', description: 'Pubu 電子書城' },
  { name: 'OverDrive', url: 'https://www.overdrive.com/publishers/清文華泉', description: 'OverDrive 圖書館電子書' },
  { name: 'MyBook', url: 'https://mybook.mobi/mybook/zh-TW/#', description: 'MyBook 電子書' },
  { name: 'Hami Book', url: 'https://www.hamibook.com.tw/Search/finish?keyword=清文華泉', description: 'Hami Book 電子書' },
];